<template>
  <div id="map-container" ref="mapContainer">
    <!-- Maps Embed APIを使ったGoogle Mapsの表示 -->
    <iframe id="map" :src="mapEmbedUrl" :style="{ width: mapWidth, height: '500px' }" allowfullscreen loading="lazy"
      ref="map"></iframe>
    <div id="places" ref="places" :style="{ width: placesWidth }" v-if="showPlaces">
      <div class="tabs">
        <ul>
          <li class="tab" :class="{ active: activeTab === 'attractions' }" @click="activeTab = 'attractions'">観光スポット</li>
          <li class="tab" :class="{ active: activeTab === 'restaurants' }" @click="activeTab = 'restaurants'">レストラン</li>
          <li class="tab" :class="{ active: activeTab === 'lodging' }" @click="activeTab = 'lodging'">宿泊施設</li>
        </ul>
      </div>
      <div class="tab-container">
        <div class="tab-content" v-show="activeTab === 'attractions'" id="attractions">
          <div v-for="attraction in attractions" :key="attraction.id" class="item">
            <h3 class="clickable" @click="showPin(attraction.name, attraction.place_id)">{{ attraction.name }}</h3>
            <p>{{ attraction.description }}</p>
          </div>
        </div>
        <div class="tab-content" v-show="activeTab === 'restaurants'" id="restaurants">
          <div v-for="restaurant in restaurants" :key="restaurant.id" class="item">
            <h3 class="clickable" @click="showPin(restaurant.name, restaurant.place_id)">{{ restaurant.name }}</h3>
            <p>{{ restaurant.description }}</p>
          </div>
        </div>
        <div class="tab-content" v-show="activeTab === 'lodging'" id="lodging">
          <div v-for="lodging in lodging" :key="lodging.id" class="item">
            <h3 class="clickable" @click="showPin(lodging.name, lodging.place_id)">{{ lodging.name }}</h3>
            <p>{{ lodging.description }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  props: {
    islandDetail: {
      type: Object,
      required: true,
      // default: () => ({})
      default: () => null
    }
  },
  data() {
    return {
      mapWidth: '50%',
      placesWidth: '50%',
      showPlaces: true,
      activeTab: 'attractions',
      attractions: [],
      restaurants: [],
      lodging: [],
      mapEmbedUrl: '' // Maps Embed API のURL
    };
  },
  watch: {
    islandDetail: {
      // immediate: true,
      handler(newVal) {
        if (newVal && Object.keys(newVal).length !== 0 && newVal.map && newVal.path) {
          this.setMapEmbedUrl(newVal.map.latitude, newVal.map.longitude, newVal.map.maxZoom);
          this.loadData();
        } else {
          console.error('Island detail or map data is missing.', newVal);
        }
      }
    }
  },
  // mounted() {
  //   this.loadData();
  // },
  methods: {
    loadData() {
      if (!this.islandDetail || !this.islandDetail.path) {
        console.error('islandDetail.path is missing.');
        return;
      }
      const pathWithoutSlash = this.islandDetail.path.replace(/^\/+/, '');
      const filename = `./pub/data/${pathWithoutSlash}_places.json`;
      // const filename = `./pub/data/${this.islandDetail.path}_places.json`;
      // Load the JSON data from the specified path
      // axios.get('./pub/data/iki_places.json')
      axios.get(filename)
        .then((response) => {
          // this.attractions = response.data.attractions;
          // this.restaurants = response.data.restaurants;
          // this.lodging = response.data.lodging;
          const data = response.data;
          // データが存在するか確認
          if (
            (data.attractions && data.attractions.length > 0) ||
            (data.restaurants && data.restaurants.length > 0) ||
            (data.lodging && data.lodging.length > 0)
          ) {
            // データが存在する場合
            this.attractions = data.attractions || [];
            this.restaurants = data.restaurants || [];
            this.lodging = data.lodging || [];
            this.mapWidth = '50%';
            this.placesWidth = '50%';
            this.showPlaces = true;
          } else {
            // データが空の場合
            this.handleNoData();
          }
        })
        .catch((error) => {
          if (error.response && error.response.status === 404) {
            console.warn('データファイルが存在しません。データなしで続行します。');
            this.handleNoData();
          } else {
            console.error('Failed to load data:', error);
            this.handleNoData();
          }
        });
    },
    handleNoData() {
      // データを空に初期化
      this.attractions = [];
      this.restaurants = [];
      this.lodging = [];
      // レイアウトを調整
      this.mapWidth = '100%';
      this.placesWidth = '0%';
      this.showPlaces = false;
    },
    setMapEmbedUrl(lat, lng, zoom) {
      // VUE_APP_GMAP_API_ID
      const apiKey = process.env.VUE_APP_GMAP_API_ID;
      this.mapEmbedUrl = `https://www.google.com/maps/embed/v1/view?key=${apiKey}&center=${lat},${lng}&zoom=${zoom}&maptype=roadmap`;
    },
    showPin(name, placeId) {
      window.open(`https://www.google.com/maps/place/?q=place_id:${placeId}`, '_blank');
    }
  }
}
</script>

<style>
#map-container {
  display: flex;
  flex-direction: row;
  width: 100%;
}

/*
#map,
#places {
  width: 50%;
}
*/

#map {
  min-height: 300px;
}

.tab {
  cursor: pointer;
  padding: 10px;
  display: inline-block;
}

.tab.active {
  background-color: #ccc;
}

@media (max-width: 600px) {
  #map-container {
    flex-direction: column;
  }

  #map,
  #places {
    width: 100% !important;
  }
}

.clickable {
  cursor: pointer;
}
</style>